import {
  deleteObject,
  getDownloadURL,
  listAll,
  ref,
  uploadBytes,
} from "firebase/storage";
import React, { useEffect, useState } from "react";
import { storage } from "../services/firebase";
import { Box, Button, Input, Modal } from "@mui/material";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import PhotoIcon from '@mui/icons-material/Photo';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const GestionarPublicidad = () => {
  const { setTittleContenido }: any = useTittleContenidoStore();
  const [images, setImages] = useState<any>([]);
  const [file, setFile] = useState<any>(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalImagenOpen, setIsModalImagenOpen] = useState(false);
  const [selectedImagerUrl, setSelectedImageUrl] = useState("");
  //obtener imagenes de storage de firebase para carousel
  const fetchImages = async () => {
    try {
      setLoading(true);
      const imagesRef = ref(storage, "imagesCarouselPrincipal/");
      const imageList = await listAll(imagesRef);
      const imageUrls = await Promise.all(
        imageList.items.map((itemRef) => getDownloadURL(itemRef))
      );
      setImages(imageUrls);
    } catch (error) {
      console.error("Error al obtener las imagenes:", error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar las imágenes cuando el componente se monta
  useEffect(() => {
    setTittleContenido("Imágenes para carousel");
    fetchImages();
  }, []);

  //subir imagenes a storage de firebase para carousel
  // Función para manejar la selección de archivos solamente de imagen
  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  // Función para subir una nueva imagen
  const handleUpload = async () => {
    if (!file) return alert("Por favor, selecciona una imagen");
    const uniqueName = `imagesCarouselPrincipal/${Date.now()}_${
      file.nombreImagen
    }`;
    const imageRef = ref(storage, uniqueName);

    try {
      setLoading(true);
      await uploadBytes(imageRef, file);
      alert("Imagen subida correctamente");
      setFile(null);
      fetchImages();
    } catch (error) {
      console.error("Error al subir la imagen:", error);
    } finally {
      setLoading(false);
    }
  };

  // Función para borrar una imagen
  const handleDelete = async (imageUrl: any) => {
    const imageRef = ref(storage, imageUrl);
    try {
      setLoading(true);
      await deleteObject(imageRef);
      alert("Imagen borrada correctamente");
      fetchImages();
    } catch (error) {
      console.error("Error al borrar la imagen:", error);
    } finally {
      setLoading(false);
    }
  };

  //funcion para expandir imagen al hacer clic sobre ella y ponerla en un modal flotante sobre la pantalla
  const expandirImagen = (imageUrl: any) => {
    setSelectedImageUrl(imageUrl);
    setIsModalImagenOpen(true);
  };

  const handleCloseModalImagen = () => {
    setIsModalImagenOpen(false);
  };

  return (
    <div>
      {loading && <BackdropComponent enabled={loading} />}
      {/* Subir nueva imagen, solamente formato imagen*/}
      <div className="d-flex flex-row justify-content-between h-100">
        <div className="d-flex flex-column align-items-center border-end">
          <h4>Elegir una imagen para subir</h4>
          <div className="d-flex justify-content-between me-5 vh-100 mt-5">
            <Box className="m-2">
              {/* Input básico de HTML con atributo accept */}
              <input
                type="file"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="file-input"
                accept=".jpg,.jpeg,.png,.gif" // Solo permite seleccionar archivos de imagen
              />
              <label htmlFor="file-input">
                <Button
                  variant="contained"
                  component="span"
                  color="secondary"
                  startIcon={<PhotoIcon />}
                >
                  Seleccionar imágen
                </Button>
                {/* Mostrar el nombre del archivo seleccionado */}
                {fileName && (
                  <p className="mt-5">
                    <b>Archivo seleccionado: </b>
                    {fileName}
                  </p>
                )}
              </label>
            </Box>
            <Box className="m-2">
              <Button
                onClick={handleUpload}
                variant="contained"
                component="span"
                className="ms-3"
                color="primary"
              >
                <CloudUploadIcon className="me-2" />
                Subir Imagen
              </Button>
            </Box>
          </div>
        </div>
        {/* Mostrar lista de imágenes */}{" "}
        <div className="ms-5">
          <h4 className="text-center">Lista de imagenes en carousel</h4>
          
          <div style={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }}>
            {images.map((imageUrl: any, index: any) => (
              <div key={index} style={{ margin: "10px" }}>
                <img
                  src={imageUrl}
                  alt={`Imagen ${index}`}
                  style={{
                    width: "250px",
                    height: "150px",
                    objectFit: "cover",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                  onClick={() => expandirImagen(imageUrl)}
                />

                <Button
                  onClick={() => handleDelete(imageUrl)}
                  variant="outlined"
                  color="error"
                  style={{ display: "block", margin: "auto", marginTop: "5px" }}
                >
                  Borrar
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal
        open={isModalImagenOpen}
        onClose={handleCloseModalImagen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <img src={selectedImagerUrl} alt="Imagen" style={{ width: "100%" }} />
        </Box>
      </Modal>
    </div>
  );
};

export default GestionarPublicidad;
